module.exports = __webpack_public_path__ + "img/infographic.f9dc17ca.png";